<template>
  <router-view></router-view>
</template>

<script>
import './Projects/store';
import './Records/store';
export default {
  name: 'lever'
};
</script>

<style lang="less" scoped></style>
